import "./checkboxListView.scss";

import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import preprocessorQuery from "../../utils/preprocessorQuery";
import FormCheckbox from "../form/FormCheckbox";

const isMobile = preprocessorQuery.isMobile();

const renderOptions = (items, onChange) =>
  items.map(o => (
    <FormCheckbox
      key={o.value}
      checkboxState={o.selected}
      label={o.label}
      onChange={state => onChange(o.value, state)}
      isCheckboxStyle={!isMobile}
    />
  ));

const CheckboxListView = props => {
  return <div className="checkboxListView">{renderOptions(props.items, props.onChange)}</div>;
};

CheckboxListView.propTypes = {
  items: PropTypeShapes.listOptionList.isRequired,
  onChange: PropTypes.func.isRequired
};

export default CheckboxListView;
